import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asignacion-transportador-agencia',
  templateUrl: './asignacion-transportador-agencia.component.html',
  styleUrls: ['./asignacion-transportador-agencia.component.css']
})
export class AsignacionTransportadorAgenciaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
